module.exports = __webpack_public_path__ + "static/media/sroty.d13faae7.png";